/**
 * @file 概览页面
 */
<template>
  <div v-if="overViewInfo" class="p-overview">
    <!-- 阈值提醒、剩余可建分账号数、新建分账号：不受资源点结算模式影响，始终展示 -->
    <div class="p-overview-toolbar">
      <span class="p-overview__subTitle" @click="handleOpenReminder">阈值提醒</span>
      <span class="p-overview-toolbar__count">剩余可建分账号数：{{ remainGroupUserCount }}</span>
      <plv-button class="p-account-add__btn" @click="handleToAddAccount">新建分账号</plv-button>
    </div>
    <!-- 资源点结算模式开启：资源点概览 -->
    <div v-if="resourcePointSettlementEnable" class="p-overview-platform">
      <div class="p-overview-platform__balance">
        <overview-card title="剩余总资源点">
          <div class="p-overview-platform__balance__num">
            {{ resourcePointRemain }}
          </div>
        </overview-card>
      </div>
      <div v-if="resourceLimitEnable" class="p-overview-platform__balance p-overview-platform_distribution">
        <overview-card title="剩余可分配资源点">
          <div class="p-overview-platform__balance__num">
            {{ resourcePointAssignable }}
          </div>
        </overview-card>
      </div>
      <div class="p-overview-platform__detail">
        <overview-card>
          <div class="p-overview-platform__detail__content">
            <plv-column>
              <plv-column-item prefix="剩余可分配资源点到期时间">{{ overViewInfo.resourcePointEndDate | formatDate('yyyy-MM-dd') }}</plv-column-item>
              <plv-column-item prefix="分账号剩余资源点">{{ subAccountResourcePointRemain }}</plv-column-item>
            </plv-column>
          </div>
        </overview-card>
      </div>
    </div>
    <!-- 资源点结算模式关闭：金额概览 -->
    <div v-else class="p-overview-platform">
      <!-- 余额 -->
      <div class="p-overview-platform__balance">
        <overview-card title="当前剩余（元）">
          <div class="p-overview-platform__balance__num">
            {{ (balanceInfoVO.validAmount - balanceInfoVO.waitPayAmount) | creditFormat }}
          </div>
        </overview-card>
      </div>
      <div v-if="resourceLimitEnable" class="p-overview-platform__balance p-overview-platform_distribution">
        <overview-card title="当前剩余可分配（元）">
          <div class="p-overview-platform__balance__num">
            {{ assignableResourceVO.amountAssignable ? assignableResourceVO.amountAssignable : '-' }}
          </div>
        </overview-card>
      </div>
      <!-- 平台账号信息 -->
      <div class="p-overview-platform__detail">
        <overview-card>
          <div class="p-overview-platform__detail__content">
            <plv-column>
              <plv-column-item prefix="授信额度">{{ balanceInfoVO.totalCredit | creditFormat }}</plv-column-item>
              <plv-column-item prefix="余额到期时间">{{ overViewInfo.amountEndDate | formatDate('yyyy-MM-dd') }}</plv-column-item>
            </plv-column>
          </div>
        </overview-card>
      </div>
    </div>
    <plv-tabs tab-min-width="88px">
      <plv-tab-panel label=" 账户信息">
        <!-- 账号产品信息 -->
        <div class="p-overview-service">
          <div class="p-overview-service__l">
            <overview-card v-if="liveOverViewInfo" title="云直播">
              <div class="p-overview-service__rtc p-table-width">
                <plv-table :data="cloudTabelData" :show-header="false">
                  <plv-table-column prop="labelName" />
                  <plv-table-column prop="count" />
                  <plv-table-column v-if="resourceLimitEnable" prop="distribution" />
                </plv-table>
              </div>
            </overview-card>
            <overview-card title="素材库">
              <div v-if="overViewInfo.materialEnabled && !ynToBool(overViewInfo.materialEnabled)" class="p-overview-service__tips">未开通</div>
              <div v-else class="p-overview-service__material p-table-width">
                <plv-column>
                  <plv-column-item prefix="空间到期时间">
                    {{ overViewInfo.materialSpaceEndDate ? (formatDate(overViewInfo.materialSpaceEndDate, 'yyyy-MM-dd')) : '未购买' }}
                  </plv-column-item>
                  <plv-column-item prefix="流量到期时间">
                    {{ overViewInfo.materialTrafficEndDate ? (formatDate(overViewInfo.materialTrafficEndDate, 'yyyy-MM-dd')) : '未购买' }}
                  </plv-column-item>
                </plv-column>
                <plv-table :data="materialTabelData" :show-header="false">
                  <plv-table-column prop="labelName" />
                  <plv-table-column prop="count" />
                  <plv-table-column prop="distribution" />
                </plv-table>
              </div>
            </overview-card>
          </div>
          <div class="p-overview-service__r">
            <overview-card title="云点播">
              <div class="p-overview-service__vod p-table-width">
                <plv-table :data="vodTabelData" :show-header="false">
                  <plv-table-column prop="labelName" />
                  <plv-table-column prop="count" />
                  <plv-table-column v-if="resourceLimitEnable" prop="distribution" />
                </plv-table>
              </div>
            </overview-card>

            <overview-card title="研讨会">
              <div class="p-overview-service__vclass">
                <plv-column>
                  <plv-column-item prefix="研讨会服务">
                    {{
                      overViewInfo.seminarEnabled ? '已开通' : '未开通'
                    }}
                  </plv-column-item>
                </plv-column>
              </div>
            </overview-card>
          </div>
        </div>
      </plv-tab-panel>
      <plv-tab-panel label=" 系统功能">
        <div class="p-system-setting">
          <div>
            <p>云直播</p>
            <div class="p-cloud-title">
              <div class="p-cloud-system-setting">系统设置</div>
              <plv-checkbox-group
                v-model="checkedSettings"
                :checkboxs="systemSettings"
              />
              <div class="p-cloud-definition">
                <p>清晰度</p>
                <div class="p-continuous-wheat">
                  <span>音视频连麦：{{ overViewInfo.rtcMaxResolution }} P</span>
                  <span>音视频连麦人数：{{ interactNumLimit }}</span>
                  <plv-checkbox
                    disabled
                    :checked="ynToBool(overViewInfo.multiplexingEnabled)"
                    label="混流"
                    class="p-checkbox-mixin"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <p>云点播</p>
            <div class="p-cloud-title">
              <plv-checkbox
                disabled
                :checked="ynToBool(overViewInfo.advanceStatsEnabled)"
                label="高级分析"
                class="p-cloud-title"
              />
            </div>
          </div>
        </div>
      </plv-tab-panel>
    </plv-tabs>
    <threshold-reminder :visible.sync="reminderVisible" @close="reminderVisible = false" />
  </div>
</template>

<script>
import OverviewCard from '@component/overviewCard/overviewCard';
import ThresholdReminder from './components/thresholdReminder';
import { commafy, formatBytesToGb } from '@/utils/utils';
import { chargeTypeEnum, chargeType } from '@/utils/type';
import { DatePicker } from '@polyv/polyv-ui';
import { mapState } from 'vuex';

// 直播表格列表
const cloudTable = {
  chargeType: '计费模式',
  resources: '资源项',
  concurrency: '并发数',
  minutes: '直播分钟数',
  liveFlow: '直播流量',
  channelGuideMinutes: '云导播台分钟数',
  frequencyChannelNum: '频道数',
  linkMicMinutes: '连麦分钟数',
  liveEndDate: ''
};

// 点播表格列表
const vodTable = {
  vodEndDate: '点播到期时间：',
  resources: '资源项',
  availableSpace: '空间',
  availableFlow: '流量',
};

// 系统设置
const checkboxsValue = {
  lotteryEnabled: 'lotteryEnabled',
  questionnaireEnabled: 'questionnaireEnabled',
  recordMp4Enabled: 'recordMp4Enabled',
  shareEnabled: 'shareEnabled',
  liveProductEnabled: 'liveProductEnabled',
  watchUserSystemEnabled: 'watchUserSystemEnabled',
  userChildrenEnabled: 'userChildrenEnabled',
  chatUserStatusCallbackEnabled: 'chatUserStatusCallbackEnabled',
  chatUserListCallbackEnabled: 'chatUserListCallbackEnabled'
};
export default {
  components: {
    OverviewCard,
    ThresholdReminder,
  },
  filters: {
    // 授信额度需要除以10w
    creditFormat(value) {
      if (value === undefined || value === null) return '-';
      return commafy(value / 100000);
    }
  },
  data() {
    return {
      overViewInfo: null,
      reminderVisible: false,
      loading: false,
      checkedSettings: []
    };
  },
  computed: {
    ...mapState({
      customInfo: (state) => state.account.customInfo,
    }),

    // 格式化直播表格数据
    formatCloudDataList() {
      const cloudDataObj = {
        chargeType: '计费模式',
        resources: '剩余用量',
        frequencyChannelNum: this.overViewInfo.packageChannels - this.overViewInfo.usedChannels,
        channelGuideMinutes: this.overViewInfo.channelGuideMinutes,
        linkMicMinutes: this.overViewInfo.linkMicMinutes,
        liveEndDate: this.overViewInfo.liveEndDate
      };
      if (this.overViewInfo.chargeType === chargeTypeEnum.LiveFlow) {
        cloudDataObj.liveFlow = formatBytesToGb(this.overViewInfo.availableLiveFlow);
      } else if (this.overViewInfo.chargeType === chargeTypeEnum.Minutes) {
        cloudDataObj.minutes = this.overViewInfo.minutes ?? 0;
      } else {
        cloudDataObj.concurrency = this.remain;
      }

      return cloudDataObj;
    },

    // 云直播剩余可分配资源
    assignableResourceCloudTable() {
      return {
        frequencyChannelNum: this.overViewInfo.packageChannels - this.overViewInfo.usedChannels,
        concurrency: this.assignableResourceVO.concurrenceAssignable ?? 0, // 并发剩余可分配
        minutes: this.assignableResourceVO.durationAssignable ?? 0, // 分钟数剩余可分配
        liveFlow: this.assignableResourceVO.liveFlowAssignable + ' GB', // 流量包剩余可分配
        channelGuideMinutes: this.assignableResourceVO.guideDurationAssignable ?? 0, // 导播台分钟数剩余可分配
        linkMicMinutes: this.assignableResourceVO.micDurationAssignable ?? 0 // 连麦分钟数剩余可分配
      };
    },

    // 云点播剩余可分配资源
    assignableResourceVodTable() {
      return {
        resources: '剩余可分配',
        availableFlow: (this.assignableResourceVO.trafficAssignable ?? 0) + ' G', // 流量包剩余可分配
        availableSpace: (this.assignableResourceVO.spaceAssignable ?? 0) + ' G', // 增容空间剩余可分配
      };
    },

    // 点播表格展示数据
    vodTabelData() {
      const vodTabelDataArray = [];
      for (const key in vodTable) {
        vodTabelDataArray.push({
          labelName: vodTable[key],
          count: Object.keys(this.vodOverViewInfo).includes(key) ? this.formatBytesToGb(this.vodOverViewInfo[key], key) : '剩余用量',
          type: key
        });
      }
      if (this.resourceLimitEnable) {
        for (const item of vodTabelDataArray) {
        // eslint-disable-next-line no-prototype-builtins
          if (this.assignableResourceVodTable.hasOwnProperty(item.type)) {
            item.distribution = this.assignableResourceVodTable[item.type];
          }
        }
      }
      return vodTabelDataArray;
    },

    // 直播表格展示数据
    // eslint-disable-next-line sonarjs/cognitive-complexity
    cloudTabelData() {
      const cloudTabelDataArray = [];
      for (const key in this.formatCloudDataList) {
        if (cloudTable[key] === '计费模式') {
          cloudTabelDataArray.push({
            labelName: `${cloudTable[key]}：${chargeType[this.overViewInfo.chargeType] ?? '-'}`,
            count: `直播到期时间：${this.formatDate(this.formatCloudDataList.liveEndDate, 'yyyy-MM-dd')}`,
          });
        } else if (cloudTable[key] !== '') {
          cloudTabelDataArray.push({
            labelName: cloudTable[key],
            count: this.formatCloudDataList[key],
            type: key
          });
        }
      }
      if (this.resourceLimitEnable) {
        for (const item of cloudTabelDataArray) {
          if (item.type) {
          // eslint-disable-next-line no-prototype-builtins
            if (this.assignableResourceCloudTable.hasOwnProperty(item.type)) {
              item.distribution = this.assignableResourceCloudTable[item.type];
            } else {
              item.distribution = '剩余可分配';
            }
          }
        }
      }
      // console.log(this.ynToBool(this.overViewInfo.resourceLimit));
      return cloudTabelDataArray;
    },
    // 素材库
    materialTabelData() {
      return [
        {
          labelName: '资源项',
          count: '剩余用量',
          distribution: '剩余可分配'
        },
        {
          labelName: '空间',
          count: this.formatBytesToGb(this.overViewInfo.availableMaterialSpace),
          distribution: this.formatBytesToGb(this.overViewInfo.assignableResourceVO.materialSpaceAssignable),
        },
        {
          labelName: '流量',
          count: this.formatBytesToGb(this.overViewInfo.availableMaterialTraffic),
          distribution: this.formatBytesToGb(this.overViewInfo.assignableResourceVO.materialTrafficAssignable),
        }
      ];
    },
    // 系统checkbox设置
    systemSettings() {
      return [
        {
          label: '无延迟直播',
          value: 'pureRtcEnabled',
          disabled: true,
        },
        {
          label: 'ODM后台定制',
          value: 'odmEnabled',
          disabled: true,
        },
        {
          label: '云分发',
          value: 'ditributeEnabled',
          disabled: true,
        },
        {
          label: '课件重制',
          value: 'pptRecordEnabled',
          disabled: true,
        },
        {
          label: '美颜',
          value: 'beautyEnabled',
          disabled: true,
        },
        {
          label: 'AI扣像',
          value: 'aiVirtualBgEnabled',
          disabled: true,
        },
        {
          label: '素材库',
          value: 'materialLibraryEnabled',
          disabled: true,
        },
        {
          label: 'MP4裁剪',
          value: 'recordMp4Enabled',
          disabled: true,
        },
        {
          label: '问卷',
          value: 'questionnaireEnabled',
          disabled: true,
        },
        {
          label: '抽奖',
          value: 'lotteryEnabled',
          disabled: true,
        },
        {
          label: '分享',
          value: 'shareEnabled',
          disabled: true,
        },
        {
          label: '商品库',
          value: 'liveProductEnabled',
          disabled: true,
        },
        {
          label: '用户管理系统',
          value: 'watchUserSystemEnabled',
          disabled: true,
        },
        {
          label: '直播间子账号',
          value: 'userChildrenEnabled',
          disabled: true,
        },
        {
          label: '直播间人员状态回调',
          value: 'chatUserStatusCallbackEnabled',
          disabled: true,
        },
        {
          label: '直播间人员列表数据回调',
          value: 'chatUserListCallbackEnabled',
          disabled: true,
        },
      ];
    },
    // 概览-账户余额信息
    balanceInfoVO() {
      return this.overViewInfo.balanceInfoVO;
    },
    // 概览-剩余总资源点 = 未分配 + 已分配给分账号未用；分配不扣主账号余额，故即主账号可用资源点（user-service 已还原为点数）
    resourcePointRemain() {
      return this.balanceInfoVO?.validAmountResourcePoint ?? 0;
    },
    // 概览-剩余可分配资源点 = 主账号可用 - Σ分账号可用（PCS 已还原为点数）
    resourcePointAssignable() {
      return this.assignableResourceVO?.resourcePointAssignable ?? '-';
    },
    // 概览-分账号剩余资源点合计
    subAccountResourcePointRemain() {
      return this.overViewInfo?.subAccountResourcePointRemain ?? 0;
    },
    // 概览-账户可分配资源
    assignableResourceVO() {
      return this.overViewInfo.assignableResourceVO;
    },
    // 概览-账户云直播信息
    liveOverViewInfo() {
      return this.overViewInfo.liveInfo;
    },
    // 概览-账户云点播信息
    vodOverViewInfo() {
      return this.overViewInfo.vodInfo;
    },
    // 概览-账户计费类型
    liveChargeType() {
      return chargeType[this.overViewInfo.chargeType];
    },
    // 资源限制开关
    resourceLimitEnable() {
      return this.ynToBool(this.overViewInfo.resourceLimit);
    },
    // 主账号资源点结算模式：开启展示资源点概览，关闭展示金额概览
    resourcePointSettlementEnable() {
      return this.ynToBool(this.overViewInfo.resourcePointSettlement || 'N');
    },
    // 剩余可建分账号数
    remainGroupUserCount() {
      return Math.max(this.overViewInfo.packageGroupUserCount - this.overViewInfo.usedGroupUserCount, 0);
    },
    // 概览-剩余用量
    remain() {
      return this.overViewInfo.packageConcurrent === -1 ? '无限制' : `${this.overViewInfo.packageConcurrent ?? '-'}`;
    },
    // 概览-连麦人数
    interactNumLimit() {
      if (!this.overViewInfo.linkLimit) {
        return '未开通';
      }
      return `1 v ${this.overViewInfo.linkLimit}`;
    }
  },
  created() {
    this.getOverViewInfo();
  },
  methods: {
    formatDate(date, format) {
      if (typeof date === 'string') {
        return date;
      }
      if (!date) {
        return '已过期';
      }
      if (date === '-' || date === '--') {
        return date;
      }
      format || (format = 'yyyy-MM-dd HH:mm:ss');
      return DatePicker.formatDate(new Date(date), format);
    },

    formatBytesToGb(value, key) {
      if (key === 'vodEndDate') {
        return this.formatDate(value, 'yyyy-MM-dd');
      }
      if (!value) return '0 G';

      const k = 1024;
      const isPositive = value > 0;
      const absByte = Math.abs(value);
      const formatedData = parseFloat((absByte / Math.pow(k, 3)).toFixed(2)) + ' G';
      return isPositive ? formatedData : `-${formatedData}`;
    },

    // 处理系统功能设置
    formatSetting() {
      const setting = this.liveOverViewInfo;
      for (const key in checkboxsValue) {
        setting[key] = this.overViewInfo[key];
      }
      for (const key in setting) {
        if (setting[key] === 'Y') {
          this.checkedSettings.push(key);
        }
      }
    },

    async getOverViewInfo() {
      this.$emit('loading');
      try {
        this.overViewInfo = await this.$store.dispatch('account/getOverViewInfo');
        this.formatSetting();

        // 将点播的数据塞进点播对象里 方便展示
        this.vodOverViewInfo.vodEndDate = this.overViewInfo.vodEndDate;
      } finally {
        this.$emit('cancelLoading');
      }

    },
    handleToAddAccount() {
      this.$router.push('/group/accountAdd');
    },
    handleOpenReminder() {
      this.reminderVisible = true;
    }
  }
};
</script>

<style lang="scss">
.p-overview {
  padding: 0 18px;
  .p-overview-toolbar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &__count {
      margin-left: 40px;
    }
    .p-overview__subTitle {
      color: #2196f3;
      cursor: pointer;
      font-size: 14px;
      &:active {
        opacity: .7;
      }
    }
    .p-account-add__btn {
      margin-left: auto;
    }
  }
  .p-overview-platform {
    display: flex;
    &__balance {
      .p-overview-card {
        height: 100%;
      }
    }
    &__detail {
      flex: 2;
      height: 100%;
      margin-left: 40px;
      .p-overview-card {
        height: 100%;
      }
      &__content {
        padding: 20px 0 20px 10px;
      }
    }
    .p-overview-platform__balance__num {
      color: #2196f3;
      font-size: 32px;
      text-align: center;
      margin: 40px 0;
    }
  }
  .p-overview-service {
    margin-top: 20px;
    display: flex;
    &__l, &__r {
      flex: 1;
    }

    &__l {
      margin-right: 20px;
    }
    &__r {
      display: flex;
      flex-direction: column;
      .p-overview-card {
        flex: 1;
      }
    }
    &__rtc, &__vod, &__vclass {
      padding-top: 20px;
    }
    .p-overview-card {
      margin-bottom: 20px;
    }
  }

  .p-system-setting {
    margin-top: 20px;
    margin-left: 15px;

    .plv-checkbox {
      margin-bottom: 8px !important;
    }

    .p-cloud-title {
      margin: 15px 0 30px 15px;

      .p-cloud-system-setting {
        margin-bottom: 15px;
      }

      .p-cloud-definition {
        margin-top: 60px;

        p {
          margin-bottom: 15px;
        }

        .p-continuous-wheat {
          margin-left: 12px;

          span {
            margin-right: 30px;
          }
        }
      }
    }
    .p-vod {
      margin-bottom: 15px;
    }
  }
}

.p-overview-service__tips {
  margin: 20px 0;
  font-size: 14px;
}

.p-overview-service__material {
  padding-top: 20px;
}

.p-table-width {
  max-width: 579px !important;
}
.p-checkbox-mixin {
  position: relative;
  top: 3px;
  margin-left: -20px;
  span {
    margin-right: 0 !important;
  }
}
.p-overview-platform_distribution {
  margin-left: 20px;
}
</style>
